import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4389bc08"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "section--column--center--full section--center__separate1 process2fa__wrapper__security"
}
const _hoisted_2 = { class: "flex__separate05" }
const _hoisted_3 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_infoauthapp2fa = _resolveComponent("infoauthapp2fa")!
  const _component_authenticatorapp2fa = _resolveComponent("authenticatorapp2fa")!
  const _component_setup2fa = _resolveComponent("setup2fa")!
  const _component_validate2fa = _resolveComponent("validate2fa")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isTwoFactorAuthenticationProcess,
    "onUpdate:visible": [
      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isTwoFactorAuthenticationProcess) = $event)),
      _ctx.process2FADestroy
    ],
    style: {width: '35vw'},
    position: "center",
    showHeader: _ctx.showheader
  }, {
    default: _withCtx(() => [
      (_ctx.isTwoFactorAuthenticationProcess)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('TwoFactorAuth.TwoFactorAuthentication').toUpperCase()), 1)
            ]),
            (_ctx.isTwoFactorAuthenticationProcessInfo2FA)
              ? (_openBlock(), _createBlock(_component_infoauthapp2fa, { key: 0 }))
              : _createCommentVNode("", true),
            (_ctx.isTwoFactorAuthenticationProcessAuthApp)
              ? (_openBlock(), _createBlock(_component_authenticatorapp2fa, { key: 1 }))
              : _createCommentVNode("", true),
            (_ctx.isTwoFactorAuthenticationProcessEnableToSetup)
              ? (_openBlock(), _createBlock(_component_setup2fa, { key: 2 }))
              : _createCommentVNode("", true),
            (_ctx.isTwoFactorAuthenticationProcessEnableToValidate)
              ? (_openBlock(), _createBlock(_component_validate2fa, { key: 3 }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "showHeader", "onUpdate:visible"]))
}